import type { FeatureFlag } from './types';

export function isFlagDeprecated(flag: FeatureFlag) {
  return !!flag.deprecated;
}
